import React from 'react';

const Pricing = () => {
  return (
    <section id="pricing" className="py-16 bg-gray-100 text-center">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-semibold text-black mb-6">Pricing by Load Size</h2>
        <p className="text-lg text-gray-700 mb-8">
          I can haul 66 cubic feet in one trip, but to simplify things my truck has an 8 foot long bed.<br></br>Choose a load size that fits your needs. Transparent and fair pricing for all junk hauling jobs.
        </p>

        {/* Pricing Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Small Load */}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-2xl font-bold text-black">1/4 Load</h3>
            <p className="text-lg text-gray-700 mt-2">$45</p>
          </div>

          {/* Half Load */}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-2xl font-bold text-black">Half Load</h3>
            <p className="text-lg text-gray-700 mt-2">$90</p>
          </div>

          {/* Three-Fourths Load */}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-2xl font-bold text-black">3/4 Load</h3>
            <p className="text-lg text-gray-700 mt-2">$135</p>
          </div>

          {/* Full Load */}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-2xl font-bold text-black">Full Load</h3>
            <p className="text-lg text-gray-700 mt-2">$180</p>
          </div>
        </div>

        {/* Image Placeholder */}
        <div className="mt-12 flex justify-center">
          <div className="w-full md:w-2/3 lg:w-1/2 h-64 bg-gray-300 flex items-center justify-center rounded-lg">
            <img className="mt-12 mb-9 bg-white p-1 rounded-lg shadow-md" src="/images/Load_sizes.png" alt="Load sizes on side of truck"/>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
